import { ISubmissionState } from '@/modules/submission/store/state';
import { MutationTree } from 'vuex';
import * as MT from './mutationTypes';
import { ValidationError } from '@/models/ValidationError';

/*--------------------------------------------------/
 * Submission Mutations
 *--------------------------------------------------*/
export const SubmissionMutations: ISubmissionMutations = {
  [MT.STORE_SUBMISSION_ERRORS]: (
    state: ISubmissionState,
    {
      submissionId,
      errors
    }: { submissionId: string; errors: ValidationError[] }
  ) => (state.errors[submissionId] = errors)
};

/*--------------------------------------------------/
 * Submission Mutations Tree Interface
 *--------------------------------------------------*/
export interface ISubmissionMutations extends MutationTree<ISubmissionState> {
  [MT.STORE_SUBMISSION_ERRORS](
    state: ISubmissionState,
    payload: { submissionId: string; errors: ValidationError[] }
  ): void;
}
